import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseCategory } from '../database/offlineDatabase/types/offlineDatabaseCategory.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseCategory, 'id'>(
  () => offlineDatabase.categories,
);

const filterOptionsRepository = createOfflineFilterOptionsRepository<OfflineDatabaseCategory, 'id'>(
  () => offlineDatabase.categories,
  ['name', 'code'],
);

export const offlineCategoriesRepository = { ...commonRepository, ...filterOptionsRepository };
